export const defaultCompaniesCountPerPage = 50;
